/* eslint-disable indent */
import {dispatch} from 'od-modules/secure_store/store';
import {SET_SHOPPING_CART, SET_PRIME_MEMBER_SELECTED, SET_REPRICING_LOG} from 'od-modules/secure_store/actions';
import {saveShoppingCartAndExecuteCallback} from 'od-modules/secure_store/reducers/asyncActionCreators';
import {setSearchId} from '@edreamsodigeo/frontend-tracking-agent';

    const logger = require('od-modules/utils/logger');
    const frontendShell = require('../modules/frontend-shell');
    const frontendShellFlightResults = require('../modules/frontend-shell/flightResults');
    const Flights = require('../apps/app.flights');
    var trackingUtils = require('../modules/utils/tracking.utils');
    var currentSearchSingletonModel = require('../modules/models/current_search.singleton.model');
    const SEARCH_RETRY_LABEL = 'SEARCH_RETRY';
    const B_PARTITION = 2;
    const WAITING_PAGE_EVENT_POSITION = 4;
    const ELEMENTS_TO_REMOVE = 1;
    const DEFAULT_TIMEOUT = 3000;
    const SEARCH_COMPLETED_WITH_ERROR = ':searchCompletedWithError';
    const SEARCH_MAPI_COMPLETED_WITH_ERROR = ':searchMapiCompletedWithError';
    const SEARCH_ERROR = ':searchError';
    let searchPerformedEvents = [
        {'name': 'preSearchPerformed'},
        {'name': 'storeSearch'},
        {'name': 'prepareSearchSummary'},
        {'name': 'prepareResultsManager'},
        {'name': 'showWaitingPage'},
        {'name': 'analyticsTrackingEvents'},
        {'name': 'launchResidentDiscountGap'},
    ];
    const removeWaitingPageFromPerformedEvents = () => {
        searchPerformedEvents.splice(WAITING_PAGE_EVENT_POSITION, ELEMENTS_TO_REMOVE);
    };

    const isMobileResults2Batches = Odigeo.AB.isMobileResults2Batches && !Odigeo.SessionScope.marketingPortalIsMeta;

    if (isMobileResults2Batches) {
        removeWaitingPageFromPerformedEvents();
    }

    Odigeo.defineWidget('searchmanager', Odigeo.Widget.extend({
        modelClass: Odigeo.Model.extend({
            lastSearch: null,
            mode: '',
            dataUrl: 'search',
            dataUrlMapi: 'searchmapi',
            landingPageType: '',
            defaults: {
                type: '',
                cabinClass: '',
                directFlightsOnly: false,
                numAdults: '',
                numChildren: '',
                numInfants: '',
                kids: {
                    kid0Age: 2,
                    kid1Age: 2,
                    kid2Age: 2,
                    kid3Age: 2,
                    kid4Age: 2,
                    kid5Age: 2,
                },
                infants: {
                    infant0Age: 0,
                    infant1Age: 0,
                    infant2Age: 0,
                    infant3Age: 0,
                },
                buyPath: 'UNKNOWN',
                searchSegments: [],
                externalSelectionRequest: {},
                flexibleDates: false,
                providerSearchTimeout: null,
                firstBatchSearch: null,
                mainBatchSearch: null,
                mainBatchFlag: false,
            },
            consts: {
                TYPES: {
                    oneWayTrip: 'ONE_WAY',
                    roundTrip: 'ROUND_TRIP',
                    multipleTrip: 'MULTIPLE_DESTINATIONS',
                },
                SEARCH_PERFORMED_EVENTS: searchPerformedEvents,
            },
            init: function() {
                this.widget.options = Odigeo.Utils.parseOptions(this.widget.options);
                this.listenTo(this, 'change:searchId', this.updateSearchId);
            },
            updateSearchId(updatedModel, value) {
                if (value) {
                    setSearchId(value.toString());
                }
            },
            url: function() {
                switch (this.mode) {
                    case 'mapi':
                        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrlMapi);
                    default:
                        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
                }
            },
            set: function(attributes, options) {
                if (Odigeo._.isObject(attributes)) {
                    var attrs = Odigeo._.clone(attributes);
                    var allowed = ['iata', 'name', 'geoNodeId', 'type'];

                    if (attrs.type) {
                        attrs.type = this.consts.TYPES[attrs.type];
                    }

                    attrs.searchSegments = Odigeo._.map(attrs.searchSegments, function(segment) {
                        return {
                            departure: Odigeo._.pick(segment.departure, allowed),
                            destination: Odigeo._.pick(segment.destination, allowed),
                            dateStr: segment.dateStr,
                            time: segment.time,
                            timeWindow: segment.timeWindow,
                        };
                    });

                    attrs = Flights.convertRequest(attrs);
                    return Odigeo.Model.prototype.set.call(this, attrs, options);
                } else {
                    return Odigeo.Model.prototype.set.apply(this, Odigeo._.toArray(arguments));
                }
            },

            validate: function(attributes) {
                var attrs = attributes.itinerarySearchRequest;
                var numPassengers = attrs.numAdults + attrs.numChildren + attrs.numInfants;
                if (numPassengers < 1) {
                    return 'Not a valid number of passengers';
                }

                if (['ONE_WAY', 'ROUND_TRIP', 'MULTIPLE_DESTINATIONS'].indexOf(attrs.type) < 0) {
                    return 'Not a valid search type';
                }
                // Cabin class allowed types list based on com.odigeo.model.search.CabinType
                if (['BUSINESS', 'FIRST', 'TOURIST', 'PREMIUM_ECONOMY', 'ECONOMIC_DISCOUNTED', 'SHOW_ALL'].indexOf(attrs.cabinClass) < 0) {
                    return 'Not a valid cabin class type';
                }

                if (!Odigeo._.every(attrs.segmentRequests, function(segment) {
                    var _date = Odigeo.Utils.parseDate(segment.dateStr);
                    var date = new Date(_date.getUTCFullYear(), _date.getUTCMonth(), _date.getUTCDate());
                    var _today = new Date();
                    var today = new Date(_today.getUTCFullYear(), _today.getUTCMonth(), _today.getUTCDate());

                    if (!isNumber(segment.time)) {
                        delete segment.time;
                        delete segment.timeWindow;
                    }
                    if (!isNumber(segment.timeWindow)) {
                        delete segment.timeWindow;
                    }

                    return segment.dateStr.match(/^\d{4}-\d{2}-\d{2}$/) && date >= today &&
                        (Odigeo._.has(segment.departure, 'geoNodeId') || Odigeo._.has(segment.departure, 'iata')) &&
                        (Odigeo._.has(segment.destination, 'geoNodeId') || Odigeo._.has(segment.destination, 'iata'));
                })) {
                    return 'Not a valid segment query';
                }

                function isNumber(str) {
                    return /^\d+$/.test(str);
                }
            },

            storeSearch(data, isFirstBatch) {
                if (isFirstBatch) {
                    this.set('firstBatchSearch', {errors: data.errors});
                } else {
                    this.set('mainBatchSearch', data);
                }
            },

            shouldContinueRendering(isFirstBatch) {
                const firstBatchSearch = this.get('firstBatchSearch');
                const mainBatchSearch = this.get('mainBatchSearch');

                const mainBatchFlag = this.get('mainBatchFlag');
                if (mainBatchFlag) {
                    this.set('mainBatchFlag', false);
                }

                const batchCheck = (!!firstBatchSearch && firstBatchSearch.errors === null && !mainBatchSearch)
                    || (!firstBatchSearch && !!mainBatchSearch)
                    || (!!firstBatchSearch && !isFirstBatch && (mainBatchFlag || firstBatchSearch.errors !== null));

                return (isMobileResults2Batches && batchCheck) || !isMobileResults2Batches;
            },

            cleanUpBatchesSearches() {
                this.unset('firstBatchSearch');
                this.unset('mainBatchSearch');
            },

        }),

        search: function(data) {
            frontendShellFlightResults.logABBouncing();
            frontendShellFlightResults.logShellEnabledButMapiCallMode(this.model.mode);
            if (frontendShellFlightResults.isEnabled()) {
                this.frontendShellSearch(data);
                return;
            }
            if (frontendShellFlightResults.isInControlScope()) {
                frontendShellFlightResults.trackCounterMetric('SEARCH_FLIGHTS_TRIGGERED');
            }

            if (this.lastSearch) {
                this.lastSearch.abort();
            }

            this.model.on('invalid', function() {
                Odigeo.trigger(this.id + SEARCH_ERROR);
            }, this);

            Odigeo.trigger(this.id + ':performModelSave');
            this.performModelSave(data, 0);

            if (this.lastSearch) {
                currentSearchSingletonModel.getInstance().set(data);
            }
            this.throwSearchPerformedEvents(data);
        },

        frontendShellSearch(searchParams) {
            frontendShell.execute(({search}) => {
                if (this.model.mode === 'mapi') {
                    search.perform(searchParams);
                } else {
                    search.perform({
                        ...searchParams,
                        externalSelectionRequest: {},
                    });
                }
                frontendShellFlightResults.trackCounterMetric('SEARCH_FLIGHTS_TRIGGERED_OF2');
            });
            Odigeo.trigger('frontend-shell:toggle-flexible-dates', true);
            Odigeo.trigger('search-manager:preSearchPerformed', searchParams);
            Odigeo.trigger('search-manager:storeSearch', searchParams);
            Odigeo.trigger('search-manager:prepareCalendarGrid', searchParams);
            Odigeo.trigger('search-manager:prepareSearchSummary', searchParams);
            Odigeo.trigger('search-manager:analyticsTrackingEvents', searchParams);
            Odigeo.trigger('search-manager:launchResidentDiscountGap', searchParams);
        },

        trackFrontendShellSearchMapiWithError() {
            trackingUtils.trackPage('results_error_500');
            trackingUtils.trackEvent(
                'request_errors',
                'error:Unable to select the flight-code:meta_external_selection'
            );
        },

        performModelSave: function(data, status0Retry) {
            if (isMobileResults2Batches &&
                this.model.mode !== 'mapi' &&
                status0Retry === 0 &&
                this.isANewSearch(Odigeo.Utils.parseJson(Odigeo.Storage.get('last-search-req')), data)) {
                this.model.cleanUpBatchesSearches();
                const providerSearchTimeout = Odigeo.AB.getMobileResults2BatchesPartition === B_PARTITION
                    ? parseInt(Odigeo.JCMS.resultsFirstBatchTimeoutShort, 10) || DEFAULT_TIMEOUT
                    : parseInt(Odigeo.JCMS.resultsFirstBatchTimeoutLong, 10) || DEFAULT_TIMEOUT;
                this.lastSearch = this.triggerSearchCall(this.model, data, status0Retry, true, {providerSearchTimeout, mainBatch: false});
                Odigeo.Session.set('shouldTrackSecondBatch', true);
                Odigeo.Storage.set('last-search-req', JSON.stringify(data));
            }

            const forceNotMembership = this.model.mode === 'mapi' && Odigeo.AB.isPreCreateShoppingCartMeta;
            if (forceNotMembership) {
                this.lastSearch = this.triggerSearchCall(this.model, data, status0Retry, false, {forceNotMembership});
            } else {
                this.lastSearch = this.triggerSearchCall(this.model, data, status0Retry);
            }
        },

        performSearch: function(options) {
            const isFrontendShellEnabled = frontendShellFlightResults.isEnabled();
            var widget = this;
            var page = 'results';

            Odigeo.trigger('search-manager:prePerformSearch', page);
            if (!Odigeo._.isFunction(options.searchIsPerformable) || options.searchIsPerformable()) {
                trackingUtils.trackHomeContinuance('RESULTS');
                if (isFrontendShellEnabled) {
                    frontendShell.execute(({search}) => search.startMetric());
                } else {
                    trackingUtils.startMetric('LOAD_RESULTS_FLIGHTS' + Odigeo.AB.resultsLoadTimeTestPartitionSuffix);
                }

                // Url params, new search is performed
                Flights.getSearchData(options.params, options.fragment).then(function(searchParams) {
                    Odigeo.trigger('search-manager:startSearchWaiting', searchParams);
                    currentSearchSingletonModel.getInstance().set(searchParams);
                    trackingUtils.setCustomDimension(73, searchParams.buyPath);
                    const paramsLocation = Odigeo.Utils.decodeParams(window.location.search.substring(1));
                    const landingPageType = Odigeo.Utils.findLandingPageType(paramsLocation.landingPageType);
                    if (!isFrontendShellEnabled) {
                        Odigeo.trigger('search-manager:startSearchWaiting', searchParams);
                    }
                    // Always search with URL params
                    if (Odigeo._.isEmpty(options.params)) {
                        Odigeo.Router.navigate('results', {
                            replace: true,
                            params: Flights.searchParamsStringify(searchParams),
                        });
                    } else {
                        if (isFrontendShellEnabled) {
                            Odigeo.trigger('frontend-shell:change-search-request', searchParams);
                        }
                        Odigeo.trigger('search-manager:setCollectionMethods', searchParams.collectionMethod);
                        // searches from MAPI only has to work the first time the new user landing on the site
                        const lastRoute = Odigeo.Utils.parseJson(Odigeo.Session.get('lastRouteChange'));
                        const setForceResultsPage = Odigeo.Utils.parseJson(Odigeo.Session.get('setForceResultsPage'));

                        if (widget.isSetForceResultsPage(setForceResultsPage) &&
                            !Odigeo._.isUndefined(searchParams.externalSelectionRequest[options.mapiKey]) &&
                            Odigeo._.isNull(lastRoute)) {
                            Odigeo.trigger('search-manager:storageTracking');

                            widget.setMode('mapi');
                            widget.setLandingPageType(landingPageType);
                            Odigeo.trigger('search-manager:startMapiMetric', landingPageType);
                        } else {
                            widget.setMode('');
                        }

                        if (setForceResultsPage) {
                            Odigeo.Session.set('setForceResultsPage', false);
                        }
                        Odigeo.trigger('search-manager:checkResident', searchParams);

                        if (!Odigeo._.isFunction(options.hasCorrectSearchParams) || options.hasCorrectSearchParams(searchParams)) {
                            widget.search(searchParams);
                            Odigeo.trigger('search-manager:checkFlightsManager');
                            Odigeo.trigger('search-manager:fillChangeSearchInfo');
                        } else {
                            Odigeo.Utils.goToApplicationHome();
                        }
                    }
                }, function(error) {
                    if (Odigeo._.isUndefined(options.checkError) || error === options.checkError) {
                        // Get the latest search from LocalStorage, then launch the search
                        var search;
                        var lastSearchKey = 'lastSearch';
                        var searches;

                        Odigeo.trigger('search-manager:retrieveLastSearch', lastSearchKey);

                        searches = Odigeo.PageStorage.get(lastSearchKey);

                        if (!Odigeo._.isEmpty(searches)) {
                            search = JSON.parse(searches);
                        }

                        if (Odigeo._.isEmpty(search)) {
                            Odigeo.Utils.goToApplicationHome();
                        } else {
                            // Go to results, with the url constructed
                            currentSearchSingletonModel.getInstance().set(search);
                            Odigeo.Router.navigate('results', {
                                replace: true,
                                params: Flights.searchParamsStringify(search),
                            });
                        }
                    }
                });
            }
        },

        triggerSearchCall: function(model, data, status0Retry, firstBatch, extraAttributes) {
            const widget = this;
            const isMapiMode = model.mode === 'mapi';
            const mapiLandingPageType = model.landingPageType;
            const cachedSearches = {firstBatchSearch: model.get('firstBatchSearch'),
                mainBatchSearch: model.get('mainBatchSearch')};
            model.clear();

            if (extraAttributes) {
                Object.keys(extraAttributes).forEach((key) => model.set(key, extraAttributes[key]));
            }

            model.save(data, {
                success: this.requestSuccessHandlerBuilder(this, !!firstBatch),
                error: (model, xhr) => {
                    if (xhr.statusText !== 'abort') {
                        if (xhr.status === 0) {
                            widget.checkRetries(status0Retry, widget, data, xhr);
                        } else if (widget.isSearchCompletedWithErrors(xhr)) {
                            isMapiMode
                                ? Odigeo.trigger(widget.id + SEARCH_MAPI_COMPLETED_WITH_ERROR, mapiLandingPageType)
                                : Odigeo.trigger(widget.id + SEARCH_COMPLETED_WITH_ERROR, xhr.responseJSON.errors);
                        } else {
                            Odigeo.trigger(widget.id + SEARCH_ERROR, xhr);
                        }
                    }
                },
            });
            Object.keys(cachedSearches).forEach((search) => model.set(search, cachedSearches[search]));
        },

        checkRetries: (status0Retry, widget, data, xhr) => {
            logger.info(SEARCH_RETRY_LABEL);
            const show0Function = Odigeo.UIElements.show0Error;
            const status0RetryMax = 2;
            if (status0Retry < status0RetryMax) {
                Odigeo.UIElements.show0Error = (x) => () => x;
                Odigeo.UIElements.hideAllDialogs();
                Odigeo._.delay(function() {
                    Odigeo.UIElements.show0Error = show0Function;
                    if (Odigeo.History.getPageNameFromFragment() === 'results') {
                        widget.performModelSave(data, status0Retry + 1);
                        Odigeo._.delay(function() {
                            Odigeo.trigger(widget.id + ':showWaitingPage');
                        }, 0);
                    }
                }, 1000);
            } else {
                Odigeo.trigger(widget.id + SEARCH_ERROR, xhr);
                trackingUtils.trackPage('results', {
                    funnel: true,
                    error: {type: 'default', message: 'retry_fail'},
                });
            }
        },
        isSearchCompletedWithErrors: (xhr) => xhr.responseJSON && xhr.responseJSON.errors && xhr.responseJSON.errors.length > 0,

        isANewSearch: function(lastData, newData) {
            return Odigeo._.isNull(lastData) || !Odigeo._.isEqual(lastData, newData) || Odigeo.SessionScope.isQaDebugInfo;
        },

        isSetForceResultsPage: function(setForceResultsPage) {
            return Odigeo.Utils.getSearchId() !== setForceResultsPage && !setForceResultsPage;
        },

        throwSearchPerformedEvents: function(data) {
            Odigeo._.each(this.model.consts.SEARCH_PERFORMED_EVENTS, function(event) {
                Odigeo.trigger(this.id + ':' + event.name, data);
            }, this);
        },

        setMode: function(mode) {
            this.model.mode = mode;
        },

        setLandingPageType: function(landingPageType) {
            this.model.landingPageType = landingPageType;
        },

        requestSuccessHandlerBuilder: function(context, isFirstBatch) {
            return function(model, data) {
                if (isMobileResults2Batches) {
                    model.storeSearch(data, isFirstBatch);
                    const shouldContinueRendering = model.shouldContinueRendering(isFirstBatch);

                    if (isFirstBatch && shouldContinueRendering) {
                        trackingUtils.trackEvent('batches', 'batches_onload');
                    }
                    model.widget.initRenderProcess(context, data, shouldContinueRendering, isFirstBatch);
                } else {
                    model.widget.initRenderProcess(context, data, true, false);
                }
            };
        },

        renderResultsProcess: function() {
            this.model.attributes.mainBatchFlag = true;

            const mainBatchSearch = this.model.attributes.mainBatchSearch;
            if (mainBatchSearch) {
                this.initRenderProcess(this, mainBatchSearch, true, false);
            }
        },

        initRenderProcess: function(widget, data, shouldContinueRendering, isFirstBatch) {
            if (shouldContinueRendering) {
                Odigeo.trigger(widget.id + ':requestSuccessHandler', data);
            }

            if (widget.model.mode === 'mapi') {
                widget.processMapiSearchCompleted(data, widget.model);
            } else if (shouldContinueRendering) {
                widget._processSearchCompleted(data);
            }
        },

        getSessionSearch: function() {
            return Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters')) || {};
        },

        getSearchMapiLandingPage: function(model, data) {
            return !Odigeo._.isEmpty(data.landingPageType) ? data.landingPageType : model.landingPageType;
        },

        trackSharedSearchError: function() {
            var search = this.getSessionSearch();
            if (!Odigeo._.isUndefined(search.sharedSearch)) {
                trackingUtils.trackEvent('share_flight', 'flight_not_found');
            }
        },

        dispatchSelection(landingPageType, shoppingCartDTO) {
            return new Promise((resolve) => {
                if (Odigeo.AB.sidebarRevamp && landingPageType === 'PASSENGER' && shoppingCartDTO) {
                    dispatch({type: SET_SHOPPING_CART, entry: shoppingCartDTO});
                    dispatch({type: SET_PRIME_MEMBER_SELECTED, entry: {
                        isSubscriptionAdded: false,
                    }, merge: true});
                    resolve();
                } else {
                    resolve();
                }
            });
        },

        dispatchRepricing(repricing) {
            return new Promise((resolve) => {
                dispatch({type: SET_REPRICING_LOG, entry: repricing});
                setTimeout(() => {
                    resolve();
                    }, 1000);
            });
        },

        processMapiSearchCompleted: function(data, model = this.model) {
            var landingPageType = this.getSearchMapiLandingPage(model, data);
            if (data.errors !== null) {
                this.trackSharedSearchError();
                Odigeo.trigger(this.id + ':searchMapiCompletedWithError', model.landingPageType);
            } else {
                if (Odigeo.AB.isFareUpgradePaxRenderable) {
                    Odigeo.trigger('search-manager:storeFareFamilies', model);
                }
                if (Odigeo.AB.sidebarRevamp) {
                    saveShoppingCartAndExecuteCallback(data.shoppingCartDTO || {}, () => {
                        return this.dispatchSelection(landingPageType, data.shoppingCartDTO || {});
                    }).then(() => Odigeo.trigger(this.id + ':searchMapiCompletedSuccessfully', landingPageType, data));
                } else {
                    saveShoppingCartAndExecuteCallback(data.shoppingCartDTO || {}, () => {
                        return this.dispatchRepricing(data.repricing || {});
                    }).then(() => Odigeo.trigger(this.id + ':searchMapiCompletedSuccessfully', landingPageType, data));
                }
            }
        },

        _processSearchCompleted: function(data) {
            if (data.errors !== null) {
                Odigeo.trigger(this.id + ':searchCompletedWithError', data.errors);
            } else {
                Odigeo.trigger(this.id + ':searchCompletedSuccessfully', data);
            }
        },
    }));
